import { Controller } from "stimulus"

import improvedecision from '../src/improvedecision';

export default class extends Controller {
  static targets = [ 
    "inputBar", "shareBar", "thanksBar",
    "contributeUnsupportedBtn", "contributeUnsupportedThanksBar"
  ]

  connect() {
    this.url = this.data.get("url");
  }

  submit(data) {
    $.ajax({
      url: this.url,
      method: "PATCH",
      data: { image: data },
    });
  }

  rateGood(e) {
    e.preventDefault();
    $(this.inputBarTarget).slideUp();
    $(this.shareBarTarget).slideDown();
    this.submit({ rating: 1 });
    window.track('Images', 'rate_good', 'Rate good');
  }

  rateBad(e) {
    e.preventDefault();
    $(this.inputBarTarget).slideUp();
    $(this.thanksBarTarget).slideDown();

    var data = { rating: -1 };

    var decision = improvedecision.get();
    if(decision === undefined) {
      this.showImprovePopup();
      window.improveDialogCallback = (decision) => {
        if(decision == 'accept') {
          this.submit({ contribute: true });
        }
      }
    }
    else if(decision == 'accept') {
      data.contribute = true;
    }
    else if(decision == 'reject') {
      // nothing to do
    }
    this.submit(data);

    window.track('Images', 'rate_bad', 'Rate bad');
  }

  contributeUnsupported(e) {
    e.preventDefault();

    var decision = improvedecision.get();
    if(decision === undefined) {
      this.showImprovePopup();
      window.improveDialogCallback = (decision) => {
        if(decision == 'accept') {
          this.submit({ contribute: true });
          $(this.contributeUnsupportedBtnTarget).slideUp();
          $(this.contributeUnsupportedThanksBarTarget).slideDown();
        }
      }
    }
    else if(decision == 'accept') {
      this.submit({ contribute: true });
      $(this.contributeUnsupportedBtnTarget).slideUp();
      $(this.contributeUnsupportedThanksBarTarget).slideDown();
    }
  }

  showImprovePopup(e) {
    if(e) e.preventDefault();
    $.magnificPopup.open({
      items: {
        src: '#improvedialog-popup'
      },
      type: 'inline',
      closeOnBgClick: false
    });
  }

}
